import { BrowserFrame } from "./browser-frame";
import styled from "@emotion/styled";
import { Icon, Typography, Theme, useTheme } from "@yuno/design-system-web";
import { LeftPanel } from "./left-panel";
import { RightPanel } from "./right-panel";
import { useContext } from "react";
import { ThemeContext } from "../../../context/theme-context";
import { useTranslation } from 'react-i18next'

const Content = styled.div<{ customTheme }>`
  display: flex;
  height: 680px;
  background: ${({ customTheme }) =>
    customTheme.shopping_cart.background_color};
  position: relative;
`;

const Disclaimer = styled.div<{ theme?: Theme }>`
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 9px 0;
  background: ${({ theme }) => theme.palette.pastel.sunset};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  p {
    margin-left: 8px;
    font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
  }
`;

export const Browser = () => {
  const { t } = useTranslation()
  const theme: Theme = useTheme();
  const { customTheme } = useContext(ThemeContext);

  return (
    <BrowserFrame>
      <Content customTheme={customTheme}>
        <LeftPanel />
        <RightPanel />
      </Content>
      <Disclaimer>
        <Icon
          name="WarningCircle"
          weight="fill"
          color={theme.palette.vivid.sunset}
        />
        <Typography>{t("styles.footer")}</Typography>
      </Disclaimer>
    </BrowserFrame>
  );
};
